import { render, staticRenderFns } from "./RelatedLegisManage.vue?vue&type=template&id=1c9985dd&scoped=true&"
import script from "./RelatedLegisManage.vue?vue&type=script&lang=js&"
export * from "./RelatedLegisManage.vue?vue&type=script&lang=js&"
import style0 from "./RelatedLegisManage.vue?vue&type=style&index=0&id=1c9985dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9985dd",
  null
  
)

export default component.exports